module.exports = __webpack_public_path__ + "img/collage_img_06.5fa72c23.jpg";